import { BreadcrumbsModel } from '../../types/Breadcrumbs/BreadcrumbsModel';

export const createMobileBannerBreadcrumbs = (categoryName = '') : BreadcrumbsModel[] => ([
    {
        key: '1',
        value: 'Настройка главной',
        url: '',
    },
    {
        key: '2',
        value: 'Body мобильного приложения',
        url: '',
    },
    {
        key: '3',
        value: categoryName,
        url: '',
    },
]);
